import React from "react";
// import ProductFormModal from "../../generatedFormModal/ProductFormModal";
import IcecatFormModal from "../../generatedFormModal/IcecatFormModal";

const EditIcecat = () => {
  return (
    <div>
      <IcecatFormModal isEdit={true} />
    </div>
  );
};

export default EditIcecat;
